import Swiper from "swiper";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

function createDashedBorder(element, options = {}) {
  if (element.querySelector(".svg-border")) {
    element.querySelector(".svg-border").remove();
  }

  const { dashArray = "20 5", cornerRadius = 30, strokeWidth = 3 } = options;

  const rect = element.getBoundingClientRect();

  const adjustedWidth = rect.width + strokeWidth;
  const adjustedHeight = rect.height + strokeWidth;

  const xmlns = "http://www.w3.org/2000/svg";

  const svg = document.createElementNS(xmlns, "svg");
  svg.setAttribute("class", "svg-border");
  svg.setAttribute("width", adjustedWidth);
  svg.setAttribute("height", adjustedHeight);
  svg.setAttribute("viewBox", `0 0 ${adjustedWidth} ${adjustedHeight}`);
  svg.style.position = "absolute";
  svg.style.top = `-${strokeWidth / 2}px`;
  svg.style.left = `-${strokeWidth / 2}px`;
  svg.style.width = `calc(100% + ${strokeWidth}px)`;
  svg.style.height = `calc(100% + ${strokeWidth}px)`;
  svg.style.pointerEvents = "none";

  const path = document.createElementNS(xmlns, "path");
  const adjustedCornerRadius = Math.max(0, cornerRadius - strokeWidth / 2);
  const d = `
      M ${strokeWidth / 2 + adjustedCornerRadius},${strokeWidth / 2}
      H ${adjustedWidth - strokeWidth / 2 - adjustedCornerRadius}
      A ${adjustedCornerRadius},${adjustedCornerRadius} 0 0 1 ${adjustedWidth - strokeWidth / 2},${
        strokeWidth / 2 + adjustedCornerRadius
      }
      V ${adjustedHeight - strokeWidth / 2 - adjustedCornerRadius}
      A ${adjustedCornerRadius},${adjustedCornerRadius} 0 0 1 ${
        adjustedWidth - strokeWidth / 2 - adjustedCornerRadius
      },${adjustedHeight - strokeWidth / 2}
      H ${strokeWidth / 2 + adjustedCornerRadius}
      A ${adjustedCornerRadius},${adjustedCornerRadius} 0 0 1 ${strokeWidth / 2},${
        adjustedHeight - strokeWidth / 2 - adjustedCornerRadius
      }
      V ${strokeWidth / 2 + adjustedCornerRadius}
      A ${adjustedCornerRadius},${adjustedCornerRadius} 0 0 1 ${strokeWidth / 2 + adjustedCornerRadius},${
        strokeWidth / 2
      }
      Z
    `;
  path.setAttribute("d", d);
  path.setAttribute("fill", "none");
  path.setAttribute("stroke", "var(--accent-color)");
  path.setAttribute("stroke-width", strokeWidth);
  path.setAttribute("stroke-dasharray", dashArray);
  path.setAttribute("stroke-linejoin", "round");

  svg.appendChild(path);

  element.appendChild(svg);
}

document.querySelectorAll(".element-testimonials").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  new Swiper(container, {
    modules: [A11y, Autoplay, Pagination],
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
    },
    speed: 1000,
    spaceBetween: 16,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1536: {
        centeredSlides: numSlides > 4,
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
});

const resizeObserver = new ResizeObserver(() => {
  document.querySelectorAll(".element-testimonials figure").forEach((figure) => {
    createDashedBorder(figure);
  });
});

resizeObserver.observe(document.body);
